export default __webpack_public_path__ + "static/media/cp.f29c685d.png";